import {
  BLOG_ARTICLE_CATEGORIES,
  BLOG_ARTICLE_CATEGORY_TO_LABEL,
  BLOG_ARTICLE_PINNED_TO_OPTIONS,
  BLOG_ARTICLE_PINNED_TO_TO_LABEL,
  type BlogArticleDetails,
} from '@/client/services/blog'

import type { FormInputType } from '@/components/UI/Form/types'

export default function getBlogArticleFormInputs(
  blogArticle?: BlogArticleDetails | null
): FormInputType[] {
  const formInputs: FormInputType[] = [
    {
      label: 'Title',
      type: 'text',
      name: 'title',
      initialValue: blogArticle?.title,
      required: true,
      size: 6,
    },
    {
      label: 'Author IDs',
      sublabel: 'This is a comma-separated list of all the User IDs on this blog post. No spaces!',
      type: 'text',
      name: 'authorIds',
      initialValue: blogArticle?.authors.map(author => author.id).join(','),
      required: true,
      size: 6,
    },
    {
      label: 'Slug',
      sublabel: 'This is what shows up in the URL, like schoolhouse.world/blog/article-slug.',
      type: 'text',
      name: 'slug',
      initialValue: blogArticle?.slug,
      required: true,
      size: 6,
    },
    {
      label: 'Excerpt',
      sublabel: 'This shows up on the list of blog articles. Keep it short!',
      type: 'text',
      name: 'excerpt',
      initialValue: blogArticle?.excerpt,
      required: true,
      size: 6,
    },
    {
      label: 'Meta Description',
      sublabel: 'This is for SEO purposes. Oftentimes the same as excerpt.',
      type: 'text',
      name: 'metaDescription',
      initialValue: blogArticle?.metaDescription,
      required: true,
      size: 6,
    },
    {
      label: 'Category',
      type: 'select',
      name: 'category',
      options: BLOG_ARTICLE_CATEGORIES.map(category => ({
        value: category,
        label: BLOG_ARTICLE_CATEGORY_TO_LABEL[category],
      })),
      initialValue: blogArticle?.category,
      required: true,
      size: 6,
    },
    {
      label: 'Pinned To',
      type: 'select',
      name: 'pinnedTo',
      options: BLOG_ARTICLE_PINNED_TO_OPTIONS.map(pinnedTo => ({
        value: pinnedTo,
        label: BLOG_ARTICLE_PINNED_TO_TO_LABEL[pinnedTo],
      })),
      initialValue: blogArticle?.pinnedTo,
      required: false,
      size: 6,
    },
    {
      label: 'Published At',
      type: 'date',
      sublabel:
        'Do you want this to be published? If so, can set a date (can be in future). If not, leave blank.',
      name: 'publishedAt',
      initialValue: blogArticle?.publishedAt?.toISO(),
      required: false,
      size: 6,
    },
    {
      label: 'Body',
      type: 'rich-text',
      name: 'body',
      editorType: 'advanced',
      height: '400px',
      maxHeight: '600px',
      initialValue: blogArticle?.body,
      required: true,
      size: 6,
    },
  ]

  return formInputs
}
